(() => {
  'use strict';
  const productId = '8685137166579';
  const modelId = '47102406361331';
  const form = document.getElementById(`product_form_${productId}`);
  if (!form || form.dataset.avaAngleSync) return;
  const variants = new Map([
    ['45661982982387', 'Sin cabecera'],
    ['45661983047923', 'Con cabecera']
  ]);
  const allowed = new Set(variants.values());
  const choiceSelector = '[tda-variant-option-value]';
  const selectedClass = 'tda-customizer-customization-option-value-selected';
  const master = () => form.querySelector('[name="id"]');
  const root = () => document.getElementById(`tda-customizer-app-section-wrapper-${modelId}`);
  const choices = () => Array.from(root()?.querySelectorAll(choiceSelector) || [])
    .filter(choice => allowed.has(choice.getAttribute('tda-variant-option-value')));
  let desired = variants.get(new URL(location.href).searchParams.get('variant'))
    || variants.get(master()?.value)
    || 'Sin cabecera';
  let writingAngle = false;
  let writingTheme = false;
  let initialObserver;

  function syncTheme(value) {
    if (!allowed.has(value)) return;
    desired = value;
    const radio = Array.from(form.querySelectorAll('input[type="radio"][name="option-1"]'))
      .find(input => input.value === value);
    if (!radio) return;
    writingTheme = true;
    try {
      if (!radio.checked) radio.click();
      else if (variants.get(master()?.value) !== value) {
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    } finally {
      writingTheme = false;
    }
  }

  function syncAngle() {
    const available = choices();
    const choice = available.find(item => item.getAttribute('tda-variant-option-value') === desired);
    if (available.length !== 2 || !choice) return false;
    writingAngle = true;
    try {
      if (!choice.classList.contains(selectedClass)) choice.click();
    } finally {
      writingAngle = false;
    }
    form.dataset.avaAngleSync = 'ready';
    initialObserver?.disconnect();
    return true;
  }

  form.dataset.avaAngleSync = 'waiting';
  form.addEventListener('change', event => {
    if (writingTheme) return;
    const target = event.target;
    const value = target?.name === 'option-1' || target?.dataset?.option === 'option2'
      ? target.value
      : variants.get(master()?.value);
    if (!allowed.has(value)) return;
    desired = value;
    requestAnimationFrame(syncAngle);
  });

  document.addEventListener('click', event => {
    const choice = event.target instanceof Element ? event.target.closest(choiceSelector) : null;
    if (!choice || !root()?.contains(choice) || writingAngle) return;
    const value = choice.getAttribute('tda-variant-option-value');
    if (allowed.has(value)) syncTheme(value);
  });

  function ready() {
    syncAngle();
    requestAnimationFrame(syncAngle);
  }
  window.addEventListener('Angle3DCustomizerReady', ready);
  window.addEventListener('Angle3DCustomizerLoaded', ready);
  if (!syncAngle()) {
    initialObserver = new MutationObserver(syncAngle);
    initialObserver.observe(document.body, { childList: true, subtree: true });
  }
})();
